import { composeIO } from 'react-compose-io'
import { selecionarParceiroIO } from './SelecionarParceiro.IO'
import { SelecionarParceiroView } from './SelecionarParceiro.View'

export const SelecionarParceiro = composeIO(SelecionarParceiroView, selecionarParceiroIO)
